import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Box, alpha } from '@mui/material';
import axios from 'axios';
import { getPublicApiBase } from '../../utils/publicApi';
import { resolveBrandingLogoImageUrl } from '../../utils/publicAssetUrl';
import { PublicBrandingIdentity } from './PublicBrandingIdentity';
import PublicSiteAccessButtons from './PublicSiteAccessButtons';

/** Top navigation for public pages (Landing, Sign In, Register, etc.). */
export default function PublicSiteNav({ barVariant = 'dark', active = 'home' }) {
  const navigate = useNavigate();
  const barIsLight = barVariant === 'light';

  const [branding, setBranding] = useState({
    logoUrl: null,
    companyName: null,
    companyTagline: null,
    companyAddress: null,
    companyCity: null,
    companyZip: null,
    companyWebsite: null,
    companyContactEmail: null,
    companyNameStyle: null,
    companyTaglineStyle: null
  });

  useEffect(() => {
    let cancelled = false;
    const base = getPublicApiBase().replace(/\/+$/, '');
    axios
      .get(`${base}/branding`)
      .then((r) => {
        const d = r.data?.data || {};
        if (cancelled) return;
        const path = d.portalLogoPath;
        setBranding({
          logoUrl: path && String(path).trim() ? resolveBrandingLogoImageUrl(path) : null,
          companyName: d.companyName ?? null,
          companyTagline: d.companyTagline ?? null,
          companyAddress: d.companyAddress ?? null,
          companyCity: d.companyCity ?? null,
          companyZip: d.companyZip ?? null,
          companyWebsite: d.companyWebsite ?? null,
          companyContactEmail: d.companyContactEmail ?? null,
          companyNameStyle: d.companyNameStyle ?? null,
          companyTaglineStyle: d.companyTaglineStyle ?? null
        });
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: barIsLight ? alpha('#ffffff', 0.92) : alpha('#0f172a', 0.88),
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        color: barIsLight ? 'text.primary' : 'grey.100',
        borderBottom: '1px solid',
        borderColor: barIsLight ? alpha('#0f172a', 0.08) : alpha('#fff', 0.1)
      }}
    >
      <Toolbar sx={{ gap: 1, py: 1.25, flexWrap: 'wrap' }}>
        <Box
          sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, minWidth: 0, cursor: 'pointer' }}
          onClick={() => navigate('/')}
        >
          <PublicBrandingIdentity
            variant="toolbar"
            toolbarColorScheme={barIsLight ? 'light' : 'dark'}
            logoSrc={branding.logoUrl}
            companyName={branding.companyName}
            companyAddress={branding.companyAddress}
            companyCity={branding.companyCity}
            companyZip={branding.companyZip}
            companyWebsite={branding.companyWebsite}
            companyContactEmail={branding.companyContactEmail}
            companyTagline={branding.companyTagline}
            companyNameStyle={branding.companyNameStyle}
            companyTaglineStyle={branding.companyTaglineStyle}
          />
        </Box>
        <PublicSiteAccessButtons active={active} />
      </Toolbar>
    </AppBar>
  );
}
